import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, NgZone } from '@angular/core';
import { ErrorDialogService } from '../shared/services/error-dialog.service';
import { ApiError, Error } from 'src/api';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private errorDialogService: ErrorDialogService, private zone: NgZone) {}

  handleError(error: any) {
    console.log('Here!!!!');
    if (!(error instanceof HttpErrorResponse)) {
      const typedError: ApiError = error.rejection; // get the error object

      this.zone.run(() => {
        const errorBody: Error = Object.fromEntries(
          Object.entries(typedError.body.Error).map(([key, val]) => [key.charAt(0).toLowerCase() + key.slice(1), val])
        );

        debugger;
        if (errorBody.employeeVisitOverlaps) {
          errorBody.employeeVisitOverlaps = errorBody.employeeVisitOverlaps.map((ev) =>
            Object.fromEntries(
              Object.entries(ev).map(([key, val]) => [key.charAt(0).toLowerCase() + key.slice(1), val])
            )
          );
          this.errorDialogService.openDialog(
            errorBody.message || 'Undefined client error',
            typedError.status,
            errorBody.overlapDay,
            errorBody.employeeVisitOverlaps ? errorBody.employeeVisitOverlaps : []
          );
        }
      });
    }
  }
}
